let currentDropdown = null;
let inited = false;

const onChooseEvent = new Event('onChoose');

// Применять сразу на .select
const selectUnChoose = function(select) {
    if (select.querySelector("[active]")) {
        select.querySelector("[active]").removeAttribute("active");
    }
    if (select.closest(".failed")) {
        select.closest(".failed").classList.remove("failed");
    }

    const currentText = select.querySelector(".select__current");
    if (currentText) {
        if (
            !currentText.classList.contains(
                "select__current_placeholder"
            )
        ) {
            currentText.classList.add("select__current_placeholder");
        }

        const currentInput = select.querySelector(".select__input");
        if (!select.classList.contains("_shopaholic-sorting")) {
            // this.setAttribute("active", ""); // TODO: рассмотреть shopaholic sorting
        }

        currentText.innerText = select.getAttribute("data-placeholder");
        currentInput.setAttribute("value", "");
    }

    // select.dispatchEvent(onChooseEvent); //TODO: Видимо вызов того же эвента в котором происходит этот же вызов всё ломает.
    select.classList.remove("is-active");
    select.classList.remove("select_selected"); // указываем что выбор сделан.
}

// TODO: Переработать дропдауны чтобы они были более гибкие
const selectInit = function Select() {
    const sClassHasActiveDropdown = 'main-selection_has-active-dropdown';
    const sClassCityDropdown = 'city';
    const sClassCountryDropdown = 'country';
    const sClassShowDropdownBtn = 'select__show';
    const sClassSelectBody = 'select__body';
    const sClassSelectHeader = 'select__header';
    const sClassRenovationDropdown = 'renovation';

    const mainPageFilter = document.querySelector('.main-selection__form');
    const showDropdownBtn = document.querySelectorAll(`.${sClassShowDropdownBtn}`);
    const selectHeader = document.querySelectorAll(`.${sClassSelectHeader}`);
    const selectItem = document.querySelectorAll(".select__item");
    const selectResetItem = document.querySelectorAll(
        ".select__checkbox-reset"
    );

    function selectReset() {
        const select = this.closest(".select");

        if (select.querySelector("input:checked")) {
            select.querySelectorAll("input:checked").forEach((item) => {
                item.checked = false;
            });
        }

        const placeholder = select.querySelector('.select__current');
        if (select.classList.contains('select_with-placeholder') && placeholder) {
            placeholder.innerText = placeholder.dataset.default;
        } else {
            this.closest(".filter__item-selectitem").querySelector(
                ".select__current span"
            ).innerText = "";
        }

        const currentInput = select.querySelector(".select__input");
        currentInput.setAttribute("value", "");
    }
    function selectToggle() {
        this.parentElement.classList.toggle("is-active");

        if (this.closest('.filter__item-accordion')) {
            this.closest('.filter__item-accordion').classList.toggle('filter__item-accordion_active');
        }

        if (this.parentElement.classList.contains("is-active")) {
            currentDropdown = this.parentNode;

            if (this.parentElement.classList.contains("select_scrollable")) {
                let scrollWrap = this.closest(".select").querySelector(
                    ".select__scroll-wrap"
                );
                if (scrollWrap) {
                    let top = scrollWrap.scrollTop;
                    let heightScroll = scrollWrap.scrollHeight;
                    let height = scrollWrap.offsetHeight;
                    if (top < heightScroll - height) {
                        scrollWrap
                            .closest(`.${sClassSelectBody}`)
                            .classList.add("noscroll");
                    }
                }
            }

            if (mainPageFilter?.contains(this)) {
                mainPageFilter.classList.add(sClassHasActiveDropdown);
                mainPageFilter.dispatchEvent(new Event("open-expanded"));
                currentDropdown.closest('.main-selection__select').classList.add('main-selection__select_active')

                if (currentDropdown.closest(`.${sClassCountryDropdown}`)) {
                    currentDropdown.querySelector(`.${sClassSelectBody}`).style.width = contentWidth(mainPageFilter) + 'px';
                }

                if (currentDropdown.closest(`.${sClassCityDropdown}, .${sClassRenovationDropdown}`)) {
                    currentDropdown.querySelector(`.${sClassSelectBody}`).style.width = contentWidth(mainPageFilter) - (currentDropdown.getBoundingClientRect().left - mainPageFilter.querySelector(`.${sClassCountryDropdown}`).getBoundingClientRect().left) + 'px';
                }
            }

        } else {
            if (mainPageFilter?.contains(this)) {
                mainPageFilter.classList.remove(sClassHasActiveDropdown);
                currentDropdown.closest('.main-selection__select').classList.remove('main-selection__select_active')

                if (currentDropdown.closest(`.${sClassCityDropdown}, ${sClassCountryDropdown}`)) {
                    currentDropdown.querySelector(`.${sClassSelectBody}`).style.width = null;
                }
            }

            currentDropdown = null;
        }
        let thisSelectElement = this.parentElement;
        let els = document.querySelectorAll(".select");
        [].forEach.call(els, function thisSelectElementFunc(el) {
            if (el !== thisSelectElement) {
                el.classList.remove("is-active");
                el.closest('.main-selection__select_active')?.classList.remove('main-selection__select_active');

                if (el.closest('.filter__item-accordion')) {
                    el.closest('.filter__item-accordion').classList.toggle('filter__item-accordion_active');
                }
            }
        });
    }
    function selectChoose() {
        const select = this.closest(".select");
        if (!this.hasAttribute("active")) {
            if (select.querySelector("[active]")) {
                select.querySelector("[active]").removeAttribute("active");
            }
            if (select.closest(".failed")) {
                select.closest(".failed").classList.remove("failed");
            }
            const text = this.innerText;
            const value = this.getAttribute("data-value");
            const currentText = select.querySelector(".select__current");

            if (currentText) {
                if (
                    currentText.classList.contains(
                        "select__current_placeholder"
                    )
                ) {
                    currentText.classList.remove("select__current_placeholder");
                }
                const currentInput = select.querySelector(".select__input");
                if (!select.classList.contains("_shopaholic-sorting")) {
                    this.setAttribute("active", "");
                }
                currentText.innerText = text;
                // currentInput.value = value;
                currentInput.setAttribute("value", value);
            }
            currentDropdown = null;
        }
        select.classList.remove("is-active");
        select.classList.add("select_selected"); // указываем что выбор сделан.

        select.dispatchEvent(onChooseEvent);
    }

    selectItem.forEach((item) => {
        if (!item.closest(".select").classList.contains("select_init")) {
            item.addEventListener("click", selectChoose);
        }
    });
    selectResetItem.forEach((item) => {
        if (!item.closest(".select").classList.contains("select_init")) {
            item.addEventListener("click", selectReset);
        }
    });

    showDropdownBtn.forEach((item) => {
        if (!item.closest(".select").classList.contains("select_init")) {
            item.addEventListener('click', (e) => {
                item.closest('.select').querySelector(`.${sClassSelectHeader}`).click();
            })
        }
    });

    [].forEach.call(
        document.querySelectorAll(`.${sClassSelectHeader}`),
        function selectHeader(el) {
            if (!el.closest(".select").classList.contains("select_init")) {
                el.addEventListener("click", function selectHeaderEl(event) {
                    if (!event.currentTarget.querySelector(".select__search")) return;
                    event.currentTarget.querySelector(".select__search").value = "";
                    event.currentTarget.querySelector(".select__search").focus();
                });
            }
        }
    );
    //скролл боди селекта
    [].forEach.call(
        document.querySelectorAll(
            ".select.select_scrollable .select__scroll-wrap"
        ),
        function selectBody(el) {
            if (!el.closest(".select").classList.contains("select_init")) {
                el.addEventListener("scroll", function selectBodyEl(event) {
                    let top = event.currentTarget.scrollTop;
                    let heightScroll = event.currentTarget.scrollHeight;
                    let height = event.currentTarget.offsetHeight;

                    if (top >= heightScroll - height) {
                        event.currentTarget
                            .closest(`.${sClassSelectBody}`)
                            .classList.remove("noscroll");
                    } else {
                        event.currentTarget
                            .closest(`.${sClassSelectBody}`)
                            .classList.add("noscroll");
                    }
                });
            }
        }
    );

    selectHeader.forEach((item) => {
        if (!item.closest(".select").classList.contains("select_init")) {
            item.addEventListener("click", selectToggle);
            item.closest(".select").classList.add("select_init");
        }
    });

    if (inited) return;

    document.body.addEventListener('click', (e) => {
        const accordion = e.target.closest('.filter__item-accordion')
        const select = e.target.closest('.select');
        if (accordion && !select && accordion.querySelector('.select__header')) {
            accordion.querySelector('.select__header').click();
        }
    });

    window.addEventListener('resize', (e) => {
        if (mainPageFilter && currentDropdown?.closest(`.${sClassCityDropdown}`)) {
            currentDropdown.querySelector(`.${sClassSelectBody}`).style.width = contentWidth(mainPageFilter) + 'px';
        }
    })

    document.body.addEventListener('click', (e) => {
        if (e.target.closest('.select__submit')) {
            selectToggle.call(e.target.closest('.select'));
        }
    })

    document.body.addEventListener("click", (e) => {
        if (e.target.closest('.filter__item-accordion')) return;

        if (
            currentDropdown &&
            e.target !== currentDropdown &&
            !currentDropdown.contains(e.target)
        ) {
            currentDropdown.classList.toggle("is-active");
            currentDropdown = null;

            if (mainPageFilter) {
                mainPageFilter.classList.remove(sClassHasActiveDropdown);
                mainPageFilter.querySelector('.main-selection__select_active')?.classList.remove('main-selection__select_active')
            }
        }

        document.querySelectorAll('.filter__item-accordion_active').forEach( i => i.classList.remove('filter__item-accordion_active'));
    });

    inited = true;
};

function selectCheckbox(e) {
    const wrap = e.target.closest('.select');

    // if (!wrap?.querySelector('.checkbox, .radio')) return;

    const checked = wrap.querySelectorAll('input:checked');

    if (e.target.getAttribute('type') === 'radio') {
        let checkedArr = Array.prototype.slice.call(checked)
        let current = checkedArr.indexOf(e.target);

        checkedArr.splice(current, 1);
        checkedArr.forEach( el => {
            el.checked = false;
        });

        // Если радио то можно при клике автоматически сворачивать.
        wrap.querySelector('.select__header').click();
    };

    if (checked.length) {
        wrap.classList.add('select_has-checked');

    } else {
        wrap.classList.remove('select_has-checked');
    }

    if (e.target.closest('.main-selection')) {

        wrap.querySelector('.select__checkbox-group_more')?.classList.remove('select__checkbox-group_more');
        if (checked.length > 4) {
            checked[3].closest('.select__checkbox-group').classList.add('select__checkbox-group_more')
        }
    } else {
        const select = e.target.closest(".select_with-placeholder");

        if (select?.closest('.filter')) {
            const placeholder = select.querySelector('.select__current');
            const checked = select.querySelectorAll('input:checked');

            if (checked.length) {
                placeholder.innerText = [].map.call(checked, ((input) => {
                    return select.querySelector(`label[for="${input.id}"]`).innerText;
                })).join(', ');
            } else {
                placeholder.innerText = placeholder.dataset.default;
            }


        }
    }

}

function rangeChange(e) {
    const wrap = e.target.closest('.select');

    if (!wrap) return;
    wrap.classList.add('select_has-checked');

}

document.body.addEventListener('change', e => {
    if (e.target.closest('.select')) selectCheckbox(e);

    if (e.target.classList.contains('select__range-input')) rangeChange(e);
});

function contentWidth(element) {
    const computedStyle = getComputedStyle(element);
    const elementWidth = element.clientWidth;

    return elementWidth - (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight));
}

selectInit();
window.selectInit = selectInit;
window.selectUnChoose = selectUnChoose;
